import React from "react";
import { useLocation } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PdfPreviewLayer from "../components/PdfPreviewLayer";
import { useTranslation } from "../i18n/I18nContext";

const PdfPreviewPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <MasterLayout>
      <Breadcrumb title={location.state?.title || t("documento.title")} />
      <PdfPreviewLayer />
    </MasterLayout>
  );
};

export default PdfPreviewPage;
